import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

export const save = (props) => {
    const blockProps = useBlockProps.save();

    return (
        <div { ...blockProps }>
            <InnerBlocks.Content />
        </div>
    );
}
